// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDoUO93oOLN8J7ZEm9f7YIWSQiVe2slWyg",
  authDomain: "rolltoearn-6b508.firebaseapp.com",
  projectId: "rolltoearn-6b508",
  storageBucket: "rolltoearn-6b508.firebasestorage.app",
  messagingSenderId: "359924487894",
  appId: "1:359924487894:web:4bc03d7b948f77c9509b77",
  measurementId: "G-KNBN7GG04L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check in production, debug token in development
const appCheck = process.env.NODE_ENV === 'production' 
  ? initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider("6LdekYQqAAAAAEUZ-NhH0l-EjhL1hBf9xwpgZZ8-"),
      isTokenAutoRefreshEnabled: true
    })
  : undefined;

// Set debug token for development
if (process.env.NODE_ENV === 'development') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, appCheck };